<template>
  <div class="ad-container">
    <div v-for="(ad, index) in adsData" :key="index" class="ad-banner" @click="handleAdClick(index)">
      <div class="ad-content">
        <div class="ad-image">
          <!-- 根据文件类型选择不同的媒体元素 -->
          <template v-if="isVideo(ad.imageUrl)">
            <video :src="ad.imageUrl" autoplay loop muted playsinline></video>
          </template>
          <template v-else>
            <img :src="ad.imageUrl" :alt="ad.title" />
          </template>
        </div>
      </div>
      <span class="ad-label">potato</span>
    </div>
  </div>
  
  <!-- 广告过渡提示 -->
  <div class="ad-transition" v-if="showTransition">
    <div class="transition-content">
      <div class="spinner"></div>
      <p>正在进入商家页面，请稍候...</p>
      <div class="progress-bar">
        <div class="progress" :style="{ width: progressWidth + '%' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdBanner',
  data() {
    return {
      adsData: [
        // {
        //   title: 'potato',
        //   imageUrl: '/imges/photo_2025-04-06_22-42-42.jpg',
        //   targetUrl: 'https://potato-game.xyz'
        // },
        // {
        //   title: 'llk',
        //   imageUrl: 'https://g.gtimg.cn/music/photo_new/T053XD01003jCYnY01ugXP.gif', // MP4视频广告
        //   targetUrl: 'https://hy.yunhaoka.com/#/pages/micro_store/index?agent_id=d7cd4e438dc012542210db56129c38e0'
        // },
        
        // {
        //   title: '4-9-02',
        //   imageUrl: '/imges/photo_2025-04-09_02-46-22.jpg', // MP4视频广告
        //   targetUrl: 'https://link3.cc/6ayyds'
        // },
        {
          title: 'zj',
          imageUrl: '/imges/215fsa3-1.png', // MP4视频广告
          targetUrl: 'https://steamstart.top',
          token: '4dfe37fd926cd4d93ffab5c3f4eace543f94da4f3baa9a1f'
        },
        {
          title: 'dma',
          imageUrl: '/imges/35981jf.png', // MP4视频广告
          targetUrl: 'https://ziyuan.assiw.xyz/DMA/',
          token: 'a70bbf891bedd0be0f750332b0fb14525fecfa4087e0d06d'
        },
        // {
        //   title: 'home',
        //   imageUrl: '/imges/未标题-gg.png',
        //   targetUrl: 'https://www.assiw.xyz'
        // }
      ],
      currentAdIndex: 0,
      showTransition: false,
      progress: 0,
      progressInterval: null
    }
  },
  computed: {
    progressWidth() {
      return this.progress;
    }
  },
  methods: {
    
    isVideo(url) {
      return url.endsWith('.mp4') || url.endsWith('.webm') || url.endsWith('.ogg');
    },
    
    
    isGif(url) {
      return url.endsWith('.gif');
    },
    
    handleAdClick(index) {
      
      this.currentAdIndex = index;
      
      
      this.showTransition = true;
      this.progress = 0;

      // 获取当前广告的 token
      const token = this.adsData[index].token;
      // 如果 token 存在且不是 '#'，则请求接口
      if (token && token !== '#') {
        fetch(`https://jishuqi.steamstart.top/api/increment.php?token=${token}`)
          .catch(() => {}); // 忽略错误
      }
      
      
      this.progressInterval = setInterval(() => {
        this.progress += 5;
        if (this.progress >= 100) {
          clearInterval(this.progressInterval);
          
          window.open(this.adsData[this.currentAdIndex].targetUrl, '_blank');
          
          setTimeout(() => {
            this.showTransition = false;
          }, 500);
        }
      }, 100);
    }
  }
}
</script>

<style scoped>
.ad-container {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-bottom: 0;
}

.ad-banner {
  width: 100%;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  box-shadow: none;
  transition: transform 0.3s ease;
  margin: 0;
  padding: 0;
}

.ad-banner:hover {
  transform: scale(1.01);
}

.ad-label {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  color: rgba(255, 255, 255, 0.8);
  padding: 2px 6px;
  border-radius: 3px;
  z-index: 2;
}

.ad-content {
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 800px;
  height: auto; /* 固定高度 */
  margin: 0 auto;
  overflow: hidden;
}

.ad-image {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* 图片样式 */
.ad-image img {
  width: 100%;
  height: auto;
  max-width: 100%;
  object-fit: contain;
  display: block;
  transition: transform 0.3s ease;
}

/* 视频样式 */
.ad-image video {
  width: 100%;
  height: auto;
  max-width: 100%;
  object-fit: contain;
  display: block;
}

.ad-banner:hover .ad-image img,
.ad-banner:hover .ad-image video {
  transform: scale(1.02);
}

/* 广告过渡提示样式 */
.ad-transition {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(10, 12, 22, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  animation: fadeIn 0.3s ease;
}

.transition-content {
  background-color: var(--card-bg);
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  box-shadow: var(--glow-shadow);
  width: 90%;
  max-width: 400px;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(123, 104, 238, 0.2);
  border-radius: 50%;
  border-top-color: var(--primary-color);
  margin: 0 auto 20px;
  animation: spin 1s linear infinite;
}

.progress-bar {
  height: 6px;
  background-color: rgba(123, 104, 238, 0.2);
  border-radius: 3px;
  margin-top: 20px;
  overflow: hidden;
}

.progress {
  height: 100%;
  background-color: var(--primary-color);
  border-radius: 3px;
  transition: width 0.1s linear;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 响应式布局 */
@media screen and (max-width: 768px) {
  .ad-container {
    gap: 0;
    margin-bottom: 0;
  }
  
  .ad-content {
    width: 100%;
    height: auto; /* 移动端较小固定高度 */
    max-height: none;
  }
  
  .ad-banner {
    padding: 0;
  }
  
  .ad-label {
    font-size: 8px;
    padding: 1px 4px;
  }
}
</style> 